export const place = { id: "drive", path: "/drive", also: [{ id: "drive-retorno", path: "/drive/retorno" }] } as const;
